import { z } from 'zod';

import { weeklyStatusCountsSchema } from './weeklySummary';

export const adminFleetAlertProjectSchema = z.object({
  projectId: z.number(),
  projectName: z.string(),
  count: z.number(),
  sensorLocalIds: z.array(z.string()),
});

export const adminFleetStatusResponseSchema = z.object({
  currentCounts: weeklyStatusCountsSchema,
  activeGatewayCount: z.number(),
  totalGatewayCount: z.number(),
  operativeProjectCount: z.number(),
  projectsWithRedSensors: z.array(adminFleetAlertProjectSchema),
});

export type AdminFleetStatusResponse = z.infer<typeof adminFleetStatusResponseSchema>;
